<div class="row">
    <div class="col-5 mb-2">
        <button class="btn btn-primary" (click)="upload(createAtt);" href="javascript:void(0);"
            *ngIf="IsReadOnly==false">
            <i class="fa fa-plus-circle"></i>
            <span> {{'AddAttachment' | translate}} </span>
        </button>
        <button class="btn btn-primary ml-1" (click)="scan(openScannerModel);" *ngIf="IsReadOnly==false">
            <i class="fa fa-plus-circle"></i>
            <span> {{'Scanner' | translate}} </span>
        </button>
    </div>
    <div class="col-6"></div>

    <div>

        <table class="table table-striped">
            <thead class="bg-primary">
                <tr>
                    <th>{{'fileName'|translate}}</th>
                    <th>{{'AttachmentType'|translate}}</th>
                    <th>{{'incommingOrgName'|translate}}</th>
                    <th>{{'descriptionAtt'|translate}}</th>
                    <th>{{'Actions' | translate}}</th>
                    <!-- <th scope="col">{{"Delete" | translate}}</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let att of attachmentList">



                    <td class="p-3">{{ att.fileName}}</td>
                    <td class="p-3">{{ att.attachmentTypeName}}</td>
                    <td class="p-3" *ngIf="att.incommingOrgName=='undefined'"> - </td>
                    <td class="p-3" *ngIf="att.incommingOrgName!='undefined'"> {{att.incommingOrgName}}</td>
                    <td class="p-3" *ngIf="att.description=='undefined'"> - </td>
                    <td class="p-3" *ngIf="att.description!='undefined'"> {{att.description}}
                        <br />
                       
                        <span *ngIf="att.creatorName!=null" style="font-size: 10px;">{{'companyandBy'|translate}}:{{
                            att.creatorName}}</span>
                        <br />
                        <span *ngIf="att.createdOn!=null" style="font-size: 10px;">{{'createDate'|translate}}:{{ att.createdOn | toDateTime}}</span>

                    </td>

                    <td class="p-3">
                        <a (click)="download(att);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                            <app-feather-icons [icon]="'download'"></app-feather-icons>
                        </a>
                        <a *ngIf="att.fileType=='image/jpeg' || att.fileType=='image/jpg' || att.fileType=='image/png' || att.fileType=='application/pdf'"
                            (click)="previewPDF(att,pdfViewer)" class="btn btn-sm btn-outline-dark ms-1 pb-0">
                            <app-feather-icons [icon]="'eye'"></app-feather-icons>
                        </a>
                        <a *ngIf="IsReadOnly==false"
                            (click)="DeletePhisicalAttachment(att.attachmentId, confirmPhisicalAttach);"
                            class="btn btn-sm btn-outline-danger ms-1 pb-0">
                            <app-feather-icons [icon]="'trash'"></app-feather-icons>
                        </a>
                    </td>

                </tr>
            </tbody>
        </table>



    </div>
</div>





<!-- اضافة مرافق -->
<ng-template #createAtt let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ 'AddAttachment' | translate }}
        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form ">
            <div class="col-12 offset-1">

                <div class="card p-3">

                    <div class="form-group ">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "AttachmentType" | translate }}</label>
                            <span *ngIf="AttachType.invalid" class="alert" style="
                                color: red;
                                white-space: nowrap;
                                line-height: 0;
                                padding: 0;
                                margin-top: 8px;
                              ">
                                <div *ngIf="AttachType.errors?.required">*</div>
                            </span>
                        </div>
                        <ng-select id="AttachType" (change)="getAttachType($event)" required #AttachType="ngModel"
                            class="form-control-select" [items]="atachTypesArr" bindLabel="text" bindValue="id"
                            [(ngModel)]="attachmentTypeId" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'AttachmentType' | translate }}">
                        </ng-select>
                    </div>
                    <div class="form-group mt-3" *ngIf="caseDetails &&caseDetails.isViolation==true">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                            <label for="committieName">{{"CommitteeName" | translate}}</label>
                            <!-- <span *ngIf="committieName.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                <div *ngIf="committieName.errors?.required">
                                    *
                                </div>
                            </span> -->
                        </div>

                        <ng-select #committieName="ngModel" [ngModelOptions]="{standalone: true}"
                            placeholder="{{'CommitteeName' | translate}}" [items]="CommitteeArr"
                            [(ngModel)]="commitieId" bindLabel="text" bindValue="id" class="form-control-select"
                            name="committieName" required></ng-select>

                    </div>
                    <div class="form-group mt-3" *ngIf="attachmentTypeId==22">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "otherTypeInfo" | translate }}</label>
                        </div>
                        <input [(ngModel)]="otherTypeInfo" type="text" class="form-control" />
                    </div>
                    <div class="form-group mt-3">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "incommingOrgName" | translate }}</label>
                        </div>
                        <input [(ngModel)]="incommingOrgName" type="text" class="form-control" />
                    </div>
                    <div class="form-group mt-3">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "descriptionAtt" | translate }}</label>
                        </div>
                        <input [(ngModel)]="description" type="text" class="form-control" />
                    </div>
                    <div class="form-group mt-3 row">
                        <div class="col-8">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "Attachment" | translate }}</label>
                                <span *ngIf="selectedFile ==undefined" class="alert" style="
                          color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;
                        ">
                                    <div *ngIf="selectedFile ==undefined">*</div>
                                </span>
                            </div>
                            <input type="file" (change)="selectFile($event)"
                                accept=".mp4,.mp3,avi,.mpeg,.dat,.xlsx,.xltx,.pptx,.pdf,.doc,.docx,image/*,application/msword" />

                        </div>
                        <div *ngIf="Loader" class="loader col-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
        <button (click)="UploadFile(modal)" [disabled]="AttachType.invalid || selectedFile == undefined"
            style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal">
            {{"Add" | translate}}
        </button>
        <button type="button" class="btn btn-dark col-lg-3" (click)="modal.dismiss('Cross click');">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>

<ng-template #confirmPhisicalAttach let-modal>
    <div class="modal-header" style="justify-content: center">
        <h5 class="modal-title text-danger" id="modal-basic-title">
            <b> <app-feather-icons [icon]="'alert-triangle'" style="position:relative; top:4px;"></app-feather-icons> {{
                "ConfirmDeleteOperation" | translate }}</b>
        </h5>
    </div>
    <div class="modal-body text-center">
        <p class="alert fs-6">{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeletePhisicalAttach(modal)">
            {{ "Yes" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "No" | translate }}
        </button>
    </div>
</ng-template>

<ng-template #pdfViewer let-modal>

    <div class="modal-body text-center">


        <div style="position:absolute; top:40%; left:45%;  z-index:-1;">
            <div class="spinner-border text-success" role="status">
            </div>
            <br />
            <br />
            <span> {{'uploadFile'|translate}} ...</span>
        </div>
        <i (click)="modal.dismiss('Cross click')" style="position: absolute;z-index: 1;left: 45px;font-size: 25px;"
            class="fa fa-close"></i>

        <!-- -->
        <pdf-viewer *ngIf="pdfFile" [src]="doc" [render-text]="true" [original-size]="false" [show-all]="true"
            [show-borders]="true">


        </pdf-viewer>

        <img style="width:100%;" *ngIf="!pdfFile" [src]="image" alt="">
    </div>
</ng-template>
<ng-template #openScannerModel let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ 'Scanner' | translate }}
        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form ">
            <app-scanner   [ElementTypeId]="ElementTypeId" [BaseElementId]="BaseElementId"
                [attachTypesArr]="atachTypesArr" (HideMe)="hidescan(modal);" [hidden]="!isScan"
                (SaveScan)="reloadAfterScan();" [loadscanner]="loadscanner"></app-scanner>
        </div>
    </div>
</ng-template>